'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var VerifyEmail = _react2['default'].createClass({
    displayName: 'VerifyEmail',


    propTypes: {
        'shortGuid': _react2['default'].PropTypes.string,
        'emailAddress': _react2['default'].PropTypes.string,
        'csrf_token': _react2['default'].PropTypes.string
    },

    getInitialState: function getInitialState() {
        return {
            processing: false
        };
    },

    onSuccess: function onSuccess(data) {
        this.setState({ processing: false });
        if (!data.success) {
            console.log("There was an error requesting the email link.");
        }
    },

    onResendClick: function onResendClick(e) {

        e.preventDefault();
        var self = this;

        this.setState({ processing: true });

        var resendAddress = "/signer/sendTemplateLinkEmail";

        _superagent2['default'].post(resendAddress).type('form').send({ email_address: this.props.emailAddress }).send({ guid: this.props.shortGuid }).send({ csrf_token: this.props.csrf_token }).end(function (err, res) {
            if (!err) {
                var data = JSON.parse(res.text);
                self.onSuccess(data);
            }
        });
    },

    render: function render() {
        var spinner = this.state.processing ? _jsx('img', {
            className: 'spinner',
            style: { position: 'absolute', left: '10%' },
            src: require('signer/components/common/signature-modal/loading-spinner-16.gif'),
            width: '16',
            height: '16'
        }) : void 0;

        return _jsx('div', {
            className: 'm-verify-email row'
        }, void 0, _jsx('div', {
            className: 'm-verify-email--container'
        }, void 0, _jsx('div', {
            className: 'm-verify-email--text'
        }, void 0, _jsx('h4', {}, void 0, 'One last thing'), _jsx('img', {
            src: require('./email_icon@2x.png')
        }), _jsx('div', {}, void 0, 'We just sent you an email.'), _jsx('div', {}, void 0, 'Please open it and click \'Review Document\'.')), _jsx('div', {
            className: 'm-verify-email--resend'
        }, void 0, spinner, 'Don\'t see it in your inbox? ', _jsx('a', {
            href: '#',
            onClick: this.onResendClick
        }, void 0, 'Click here to resend.'))), _jsx('span', {
            className: 'm-verify-email--legal'
        }, void 0, 'Note: This step is required to comply with eSignature laws.'));
    }
});

module.exports = VerifyEmail;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/auth/verify-email.jsx
 ** module id = 760
 ** module chunks = 0
 **/